if (!customElements.get('nt-oil-buy')) {
  customElements.define('nt-oil-buy', class NatyoureOilBuy extends HTMLElement {
    connectedCallback() {
      this.moneyFormat = this.dataset.moneyFormat || '€{{amount_with_comma_separator}}';
      this.threshold = Number(this.dataset.threshold) || 0;
      this.variantInput = this.querySelector('[data-variant-input]');
      this.qtyInput = this.querySelector('[data-qty-input]');
      this.radios = Array.from(this.querySelectorAll('.nt-ol-format input'));

      this.radios.forEach((radio) => radio.addEventListener('change', () => this.update(true)));
      this.querySelectorAll('[data-qty]').forEach((button) => button.addEventListener('click', () => {
        this.qtyInput.value = Math.min(99, Math.max(1, this.quantity + Number(button.dataset.qty)));
        this.update();
      }));
      this.qtyInput.addEventListener('change', () => {
        this.qtyInput.value = Math.min(99, Math.max(1, this.quantity));
        this.update();
      });

      this.preselectFromUrl();
      this.initGallery();
      this.update();
    }

    // Le inserzioni possono aprire la pagina su un formato preciso: ?formato=3l oppure ?formato=250ml.
    preselectFromUrl() {
      const wanted = (new URLSearchParams(window.location.search).get('formato') || '').toLowerCase().replace(/\s+/g, '');
      if (!wanted) return;
      const match = this.radios.find((radio) => !radio.disabled && radio.dataset.label.toLowerCase().replace(/\s+/g, '').endsWith(wanted));
      if (match) match.checked = true;
    }

    get quantity() {
      return parseInt(this.qtyInput.value, 10) || 1;
    }

    get selected() {
      return this.radios.find((radio) => radio.checked) || this.radios[0];
    }

    formatMoney(cents) {
      const value = (cents / 100).toFixed(2);
      const [whole, decimals] = value.split('.');
      const group = (separator) => whole.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
      const formats = {
        amount: `${group(',')}.${decimals}`,
        amount_no_decimals: group(','),
        amount_with_comma_separator: `${group('.')},${decimals}`,
        amount_no_decimals_with_comma_separator: group('.'),
        amount_with_apostrophe_separator: `${group("'")}.${decimals}`
      };
      return this.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => formats[key] || formats.amount);
    }

    update(variantChanged) {
      const radio = this.selected;
      if (!radio) return;
      const price = Number(radio.dataset.price);
      const unit = Number(radio.dataset.unit);
      const total = price * this.quantity;

      this.variantInput.value = radio.value;
      this.setText('[data-price]', this.formatMoney(price));
      this.setText('[data-per-use]', unit ? `Circa ${this.formatMoney(Math.round(unit / 100))} per cucchiaio (10 ml)` : '');
      this.setText('[data-total]', this.formatMoney(total));
      this.updateShipping(total);

      if (variantChanged && radio.dataset.imageId) {
        const slide = this.querySelector(`.nt-ol-gallery__slide[data-image-id="${radio.dataset.imageId}"]`);
        if (slide && this.track) this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
    }

    updateShipping(total) {
      const text = this.querySelector('[data-ship-text]');
      if (!text || !this.threshold) return;
      const bar = this.querySelector('[data-ship-bar]');
      const missing = this.threshold - total;
      text.textContent = missing > 0
        ? `${this.dataset.shippingText}. Mancano ${this.formatMoney(missing)} alla spedizione gratuita.`
        : 'Spedizione gratuita inclusa in questo ordine.';
      if (bar) bar.style.width = `${Math.min(100, (total / this.threshold) * 100)}%`;
    }

    setText(selector, value) {
      const element = this.querySelector(selector);
      if (element) element.textContent = value;
    }

    initGallery() {
      this.track = this.querySelector('[data-gallery]');
      const dots = this.querySelector('[data-gallery-dots]');
      if (!this.track || !dots) return;
      const slides = Array.from(this.track.children);
      if (slides.length < 2) return;
      dots.innerHTML = slides.map(() => '<i></i>').join('');
      const mark = () => {
        const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        Array.from(dots.children).forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      };
      this.track.addEventListener('scroll', () => window.requestAnimationFrame(mark), { passive: true });
      mark();
    }

  });
}

if (!customElements.get('nt-oil-film')) {
  customElements.define('nt-oil-film', class NatyoureOilFilm extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video');
      const saveData = navigator.connection && navigator.connection.saveData;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!video || !this.dataset.videoUrl || saveData || reducedMotion || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          if (!video.getAttribute('src')) {
            video.src = this.dataset.videoUrl;
            video.addEventListener('playing', () => { video.hidden = false; }, { once: true });
          }
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }, { rootMargin: '200px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  });
}

// Ingresso morbido dei blocchi: senza JavaScript il contenuto resta visibile.
(function () {
  if (window.ntOilReveal || !('IntersectionObserver' in window)) return;
  window.ntOilReveal = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const start = () => {
    const items = document.querySelectorAll('.nt-ol [data-reveal]');
    if (!items.length) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach((item) => {
      if (item.getBoundingClientRect().top < window.innerHeight) return;
      item.classList.add('is-waiting');
      observer.observe(item);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

// Testi lunghi: su telefono si aprono a richiesta. Senza JavaScript restano tutti visibili.
(function () {
  if (window.ntOilCollapsible) return;
  window.ntOilCollapsible = true;
  const start = () => {
    document.querySelectorAll('.nt-ol [data-collapsible]').forEach((box) => {
      const toggle = box.querySelector('[data-collapsible-toggle]');
      if (!toggle) return;
      box.classList.add('is-ready', 'is-collapsed');
      toggle.addEventListener('click', () => {
        const collapsed = box.classList.toggle('is-collapsed');
        toggle.setAttribute('aria-expanded', String(!collapsed));
        toggle.textContent = collapsed ? (toggle.dataset.more || 'Continua a leggere') : (toggle.dataset.less || 'Mostra meno');
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

// Indicazioni e pulsanti per i contenuti che scorrono orizzontalmente su mobile.
(() => {
  if (window.ntOilScrollHints) return;
  window.ntOilScrollHints = true;
  let sequence = 0;
  const init = () => {
    if (!document.querySelector('.nt-ol-hero')) return;
    const selector = '.nt-ol-gallery__track, .nt-ol-marquee__viewport, .nt-ol-bundles__grid, .nt-ol-starters__grid--carousel, .nt-instagram__grid, .nt-ol-ultrasound__phases, .nt-ol-journey__track';
    document.querySelectorAll(selector).forEach(track => {
      if (track.dataset.scrollHintReady) return;
      track.dataset.scrollHintReady = 'true';
      if (!track.id) track.id = `nt-oil-scroll-${++sequence}`;
      const controls = document.createElement('div');
      controls.className = 'nt-oil-scroll-hint';
      controls.hidden = true;
      const label = document.createElement('span');
      label.textContent = 'Scorri per vedere altro';
      const previous = document.createElement('button');
      const next = document.createElement('button');
      for (const [button, direction, name] of [[previous, -1, 'Scorri indietro'], [next, 1, 'Scorri avanti']]) {
        button.type = 'button';
        button.textContent = direction < 0 ? '←' : '→';
        button.setAttribute('aria-label', name);
        button.setAttribute('aria-controls', track.id);
        button.addEventListener('click', () => track.scrollBy({left: direction * track.clientWidth * .85, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}));
      }
      controls.append(label, previous, next);
      track.after(controls);
      const update = () => {
        controls.hidden = !window.matchMedia('(max-width: 749px)').matches || track.scrollWidth <= track.clientWidth + 4;
        previous.disabled = track.scrollLeft < 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };
      let pending = false;
      track.addEventListener('scroll', () => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => { pending = false; update(); });
      }, {passive: true});
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      window.addEventListener('resize', update, {passive: true});
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

